module.exports = __webpack_public_path__ + "static/media/podcast_index.cd2cbbb3.svg";